<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" [multiTemplateDataRows]="expandableRows || groupByColumnName!==''" class="w-100" matSort matSortDisableClear
    [matSortActive]="defaultPageFilterSetting?.sortBy" [matSortDirection]="defaultSortDirection" (matSortChange)="onSortChanged($event)">

    <ng-container *ngFor="let col of _columnsDef; let iCol = index" matColumnDef="{{col.name}}">
      <ng-container *matHeaderCellDef>
        <th mat-header-cell [style.min-width]="col.widthPercentage" *ngIf="col.name != 'select'" mat-sort-header [disabled]="!col.sort">
          {{ col.text | translate }}
        </th>
        <th mat-header-cell *ngIf="col.name === 'select'" [style.width]="'48px'">
          <ng-container *ngTemplateOutlet="checkBoxHeader"></ng-container>
          <ng-container *ngIf="!checkBoxHeader">
            <mat-checkbox *ngIf="multiSelect" (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </ng-container>
        </th>
      </ng-container>

      <ng-container *matCellDef="let row; let iRow = index">
        @if(col.name === 'select'){
        <td mat-cell [class.cursor-pointer]="enableRowSelect">
          <mat-checkbox *ngIf="!row.disableRowSelection" (click)="useSingleSelectShowExpandableRows ? onShowExpandedRow($event, row) : $event.stopPropagation()"
            (change)="$event ? setSelectedRow(row) : null" [checked]="selection.isSelected(row)">
          </mat-checkbox>
          <mat-checkbox *ngIf="row.disableRowSelection" [disabled]="true">
          </mat-checkbox>
        </td>
        }
        @else if(col.isRowSpan){
        @if(dataSourceRowSpans$ | async; as rowSpans){
        @if(enableRowSelect ? rowSpans[iCol-1] : rowSpans[iCol]; as columnData){
        <td mat-cell [attr.rowspan]="columnData[iRow].span" [style.display]="columnData[iRow].span === 0 ? 'none'  : ''" [style.min-width]="col.widthPercentage"
          [class.cursor-pointer]="enableRowSelect" [class]="columnData[iRow].span > 1 ? 'row-span' : ''"
          [ngClass]="{'align-right-field': col.align === 'end' || col.dataType === 'currency', 'align-center-field': col.align === 'center', 'align-left-field': col.align === 'start'}">
          {{columnData && columnData[iRow]?.span === 0 ? "" : row[col.name] | dynamicPipe: col.pipe: col.pipeArgs}}
        </td>
        }
        }
        }
        @else {
        <td mat-cell [style.min-width]="col.widthPercentage" [class.cursor-pointer]="enableRowSelect"
          [ngClass]="{'align-right-field': col.align === 'end' || col.dataType === 'currency', 'align-center-field': col.align === 'center', 'align-left-field': col.align === 'start'}">
          <ng-container *ngTemplateOutlet="cellContent; context: {data: row, column: col}"></ng-container>
          <ng-container *ngIf="!cellContent">
            <div [innerHtml]="row[col.name] | dynamicPipe: col.pipe: col.pipeArgs"></div>
          </ng-container>
        </td>
        }

      </ng-container>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsWithExpand; sticky: stickyHeader"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsWithExpand; when: isNotGroupByHeader;"
      (click)="!row.disableRowExpandable && onShowExpandedRow($event, row); selectOnRowClick && !row.disableRowSelection ? setSelectedRow(row) : null;"
      [class.selected-row]="enableRowSelect && selection.isSelected(row)" class="expended-element-row" [class.cursor-pointer]="enableRowSelect"
      [ngClass]="{'small-row': rowSize===DataGridRowSize.SMALL,'medium-row': rowSize===DataGridRowSize.MEDIUM, 'big-row': rowSize===DataGridRowSize.BIG}">
    </tr>

    <ng-container *ngIf="expandableRows">
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expended-detail-row"></tr>
    </ng-container>
  </table>

  <app-loading-spinner [hidden]="!isLoading"></app-loading-spinner>

  <mat-paginator [hidden]="!enablePagination" [pageIndex]="defaultPageFilterSetting?.pageIndex" [pageSize]="defaultPageFilterSetting?.pageSize" [length]="dataSourceLength$ | async"
    [pageSizeOptions]="pageSizeOptions" showFirstLastButtons (page)="onPageChanged($event)">
  </mat-paginator>
</div>
